import * as Types from "../../../constants";
import produce from "immer";

let initialState = {
  designs: [],
  mockups: [],
  products: [],
  orders: [],
  ordersByDesigner: {},
};
export default (state = initialState, action = {}) => {
  return produce(state, draft => {
    switch (action.type) {
      case Types.GET_REPORT_DESIGN:
        let data = action.payload.data.results
        draft.designs = data;
        break;
      case Types.GET_REPORT_MOCKUP:
        draft.mockups = action.payload.data.results;
        break;
      case Types.GET_REPORT_ORDER:
        draft.orders = action.payload.data.results;
        break;
      case Types.GET_REPORT_ORDER_BY_DESIGNER:
        draft.ordersByDesigner = action.payload.data.results;
        break;
      case Types.GET_REPORT_PRODUCT:
        draft.products = action.payload.data.results;
        break;
      default:
        return state;
    }
  })
}

